import { ComponentsOptionsDTO } from '@modeso/types__aumico-lib-notes-be';

export interface INotesTypesWithSingleLanguage {
    _id?: any;
    name: string;
    title: string;
    componentsOptions: ComponentsOptionsDTO[];
    owner: string;
}
